module.exports = __webpack_public_path__ + "static/media/fall-2021-speakers.3930c629.jpg";